import { IRalColor } from './ral-colorpicker/ral-colors';
import { IMetalColor } from '../core/IMetalColor';

export class SpecialColorSelection {
    public isRalColor: boolean;
    /**
     * Either a ral color id or metal color id.
     */
    public colorId: number;
    public isRalMatt: boolean;
    public stringRepresentation: string;

    public setRalColor(ralColorId: number, isMatt: boolean) {
        this.isRalColor = true;
        this.colorId = ralColorId;
        this.isRalMatt = isMatt;
        this.stringRepresentation = `r${ralColorId}${isMatt ? 'm' : 'g'}`;
    }

    public setMetalColor(metalColorId: number) {
        this.isRalColor = false;
        this.colorId = metalColorId;
        delete this.isRalMatt;
        this.stringRepresentation = `m${metalColorId}`;
    }

    public fromString(stringRepresentation: string) {
        if (this.stringRepresentation === stringRepresentation)
            return;
        if (stringRepresentation === undefined) {
            delete this.isRalColor;
            delete this.colorId;
            delete this.stringRepresentation;
            delete this.isRalMatt;

            return;
        }

        const prefix = stringRepresentation.substring(0, 1);
        const suffix = stringRepresentation.substring(stringRepresentation.length - 1);

        if (prefix === 'm') {
            const metalColorId = Number(stringRepresentation.substring(1));
            this.setMetalColor(metalColorId);
        } else {
            const ralColorId = Number(stringRepresentation.substring(1, stringRepresentation.length - 1));
            this.setRalColor(ralColorId, suffix === 'm');
        }
    }

    public static fromRalColor(ralColorId: number, isMatt: boolean) {
        const result = new SpecialColorSelection();
        result.setRalColor(ralColorId, isMatt);

        return result;
    }

    public static fromMetalColor(metalColorId: number) {
        const result = new SpecialColorSelection();
        result.setMetalColor(metalColorId);

        return result;
    }

    public static fromString(stringRepresentation: string) {
        const result = new SpecialColorSelection();
        result.fromString(stringRepresentation);

        return result;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/SpecialColorSelection.ts